<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Consumable/In/'">
          <el-button type="primary" size="mini">物品入库登记</el-button>
        </router-link>

        <a :href="baseURL+'/consumable/stock/download?depId='+(depId==0?'':depId)"
          target="_blank">
          <el-button type="primary" size="mini">实时库存表下载</el-button>
        </a>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:220px;" v-model="filterKey" size="small"
        placeholder="你可以搜索物品名称/物品编号等"></el-input>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="consumable.number" label="材料编号" width="80">
      </el-table-column>
      <el-table-column prop="consumable.name" label="物品名称">
      </el-table-column>
      <el-table-column prop="consumable.spec" align="left" width="150" label="规格型号">
      </el-table-column>
      <el-table-column prop="consumable.dl.name" label="材料类别" width="150" align="left">
      </el-table-column>
      <!-- <el-table-column prop="supplier.name" label="供应商">
      </el-table-column> -->
      <el-table-column prop="consumable.unit.name" width="80" align="center" label="计量单位">
      </el-table-column>
      <el-table-column prop="amount" align="center" width="80" label="当前库存">
      </el-table-column>
      <el-table-column prop="price" align="center" width="80" label="当前单价(元)">
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,

        depId: "",

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    created() {

      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    mounted() {},
    methods: {
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.consumable.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.consumable.number
              .toLowerCase().indexOf(this.filterKey.toLowerCase()) != -
              1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ''

        ajax.get('/consumable/realTime/list', {
          depId: this.depId,
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      depId() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/roomDetail.vue